"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = exports.spacing = exports.iconSizes = exports.colors = exports.brandColors = exports.SANS_SERIF_BASE = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

// https://bitsofco.de/the-new-system-font-stack/
var SANS_SERIF_BASE = exports.SANS_SERIF_BASE = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, system-ui, Arial, sans-serif';
var brandColors = exports.brandColors = {
  streamatePrimary: "#3399cc",
  streamfansPrimary: "#ff257b",
  kwikyPrimary: "#ff257b",
  adminproPrimary: "#0dadbb",
  cambuilderPrimary: "#49c6ff",
  creatorPrimary: "#3399cc"
};
var colors = exports.colors = _objectSpread({
  // This primary color is dependent upon the primary color of the skin (#3399cc is the primary for Streamate)
  primary: "#3399cc",
  alert: "#e02020",
  warning: "#cc7d00",
  success: "#00C853",
  info: "#757575",
  // NOTE: `active` color can be different from `success`. It is used in `LiveBug` and `OnlineStatusIndicator` components.
  active: "#00C853",
  activeVariant: "#195b1e",
  textOnDark: "#ffffff",
  textOnLight: "#212121",
  baseInvariant: "#c7c7cc",
  // this color is a neutral themeBase to be used regardless of theme
  baseShadow: "#000000",
  gold: "#ffc107",
  goldVariant: "#8F680A",
  goldGradient: "linear-gradient(to bottom, #fbe112 0%, #cc7d00 100%)",
  goldGradientHover: "linear-gradient(to bottom, #fde83d, #f19502)",
  messenger: "#0B84FF"
}, brandColors);
var spacing = exports.spacing = {
  base: 8
};
var typography = exports.typography = {
  fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, "Helvetica Neue", "Helvetica", sans-serif',
  fontSize: 14,
  /**
   * 400 is 'normal' according to MDN: https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
   * 300 appeared fine in Chrome, but was rendered as 'light' in Firefox
   */
  fontWeight: 400,
  letterSpacing: 0.5,
  lineHeight: 1.45
};
var iconSizes = exports.iconSizes = {
  small: 20,
  medium: 24,
  large: 32
};